import axios from "axios";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import Select from "react-select";
import { toast } from "react-toastify";

class WageForm extends Component {
    state = {
        id: "",
        month: null,
        type: "",
        chartaccount: "",
        staffId: "",
        profile: "",
        reason: "",
        amount: "",
        year: null,
        max: 0,
        error: "",
        loading: false,
        saving: false,

        staffs: [],
        chartaccounts: [],
        months: [],
        typesalaries: [],
        years: [],
        title: "",
    };

    value = (options, id) =>
        options.find((item) => String(item.value) === String(id)) || null;

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            error: "",
        });
    };

    handleAmount = (e) => {
        const value = e.target.value;
        const amount = Number(value);

        if (!value) {
            this.setState({ amount: "", error: "" });
            return;
        }

        if (amount <= 0) {
            this.setState({
                amount: "",
                error: "Le montant doit être supérieur à zéro.",
            });
            return;
        }

        if (this.state.max > 0 && amount > this.state.max) {
            this.setState({
                amount: "",
                error: "Le montant ne peut pas dépasser le solde disponible de la caisse.",
            });
            return;
        }

        this.setState({
            amount: value,
            error: "",
        });
    };

    loadForm = async () => {
        const detail = this.props.formData?.expensedetails?.[0] || null;

        this.setState({
            id: detail ? detail.id : "",
            reason: detail ? detail.reason : "",
            amount: detail ? detail.amount : "",
            chartaccount: detail?.chartaccount ? detail.chartaccount.id : "",
            max: detail?.chartaccount ? detail.chartaccount.amount : 0,
            staffId: this.props.formData ? this.props.formData.staffId : "",
            month: this.props.formData ? this.props.formData.monthId : null,
            type: detail?.typesalary ? detail.typesalary.id : "",
            title: this.props.formData ? "Modifier un salaire" : "Ajouter un salaire",
            error: "",
            loading: true,
            saving: false,
        });

        try {
            const [staffs, chartaccounts, months, typesalaries] = await Promise.all([
                axios.get("staffs"),
                axios.get("chartaccounts"),
                axios.get("months"),
                axios.get("typesalaries"),
            ]);

            this.setState({
                staffs: staffs.data || [],
                chartaccounts: chartaccounts.data || [],
                months: months.data || [],
                typesalaries: typesalaries.data || [],
            });
        } catch (error) {
            this.setState({
                error: "Impossible de charger les options du formulaire.",
            });
        } finally {
            this.setState({ loading: false });
        }
    };

    validate = () => {
        const { staffId, type, chartaccount, month, amount, max } = this.state;

        if (!staffId) return "Le personnel est obligatoire.";
        if (!type) return "Le type de salaire est obligatoire.";
        if (!chartaccount) return "La caisse est obligatoire.";
        if (!month) return "Le mois est obligatoire.";
        if (!amount) return "Le montant est obligatoire.";

        const amountNumber = Number(amount);

        if (!Number.isFinite(amountNumber) || amountNumber <= 0) {
            return "Le montant doit être supérieur à zéro.";
        }

        if (max > 0 && amountNumber > max) {
            return "Le montant ne peut pas dépasser le solde disponible de la caisse.";
        }

        return "";
    };

    save = async (val = null) => {
        const message = this.validate();

        if (message) {
            this.setState({ error: message });
            return;
        }

        const data = {
            staffId: this.state.staffId,
            monthId: this.state.month ? this.state.month : null,
            chartaccountId: this.state.chartaccount,
            typesalaryId: this.state.type,
            reason: String(this.state.reason || "").trim(),
            amount: this.state.amount ? Number(this.state.amount) : null,
            status: "en cours",
            type_expense: "Wage",
            operation: this.state.id ? (val === 1 ? "Archiver" : "Editer") : "Ajouter",
        };

        this.setState({ saving: true, error: "" });

        try {
            const response = this.state.id
                ? await axios.put(`expensedetails/${this.state.id}`, data)
                : await axios.post("expenses", data);

            toast.success(response?.data?.msg || "Le salaire a été sauvegardé.");
            this.props.showModal(null, false, 1);
        } catch (error) {
            const errorMessage = error.response?.data?.msg || "La sauvegarde a échoué.";
            this.setState({ error: errorMessage });
            toast.error(errorMessage);
        } finally {
            this.setState({ saving: false });
        }
    };

    field = (id, icon, label, options, key, placeholder) => (
        <div className="wage-form__field">
            <label className="sectionclasse-field__label" htmlFor={id}>
                <FeatherIcon icon={icon} size={15} />
                {label} <b>*</b>
            </label>

            <Select
                inputId={id}
                classNamePrefix="sectionclasse-select"
                placeholder={placeholder}
                value={this.value(options, this.state[key])}
                onChange={(item) =>
                    this.setState({
                        [key]: item?.value || "",
                        error: "",
                    })
                }
                options={options}
                noOptionsMessage={() => "Aucune option disponible"}
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                menuPosition="fixed"
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 1060 }) }}
            />
        </div>
    );

    render() {
        const editing = Boolean(this.state.id);

        const optionstaffs = this.state.staffs.map((staff) => ({
            value: staff.id,
            label:
                (staff.user?.last_name || "") +
                " " +
                (staff.user?.family_name || "") +
                " " +
                (staff.user?.first_name || "") +
                " # " +
                (staff.matricule || ""),
        }));

        const optiontypesalaries = this.state.typesalaries
            ?.filter((type) => type.category === "Wage")
            ?.map((type) => ({
                value: type.id,
                label: type.type,
            }));

        const optionchartaccounts = this.state.chartaccounts.map((chartaccount) => ({
            value: chartaccount.id,
            label:
                chartaccount.wording +
                " # " +
                Number(chartaccount.amount || 0).toLocaleString() +
                " " +
                (chartaccount.currency || ""),
            max: chartaccount.amount,
        }));

        const optionmonths = this.state.months.map((month) => ({
            value: month.id,
            label: month.month,
        }));

        return (
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                onEntered={this.loadForm}
                size="lg"
                backdrop="static"
                centered
                dialogClassName="sectionclasse-form wage-form"
            >
                <Modal.Header className="sectionclasse-form__header">
                    <div className="sectionclasse-form__title">
                        <span>
                            <FeatherIcon icon={editing ? "edit-3" : "dollar-sign"} size={20} />
                        </span>
                        <div>
                            <small>Gestion des salaires</small>
                            <Modal.Title>
                                {editing ? "Modifier un salaire" : "Ajouter un salaire"}
                            </Modal.Title>
                        </div>
                    </div>

                    <button
                        type="button"
                        className="sectionclasse-form__close"
                        onClick={this.props.showModal}
                        aria-label="Fermer"
                    >
                        <FeatherIcon icon="x" size={18} />
                    </button>
                </Modal.Header>

                <Modal.Body className="sectionclasse-form__body wage-form__body">
                    <p className="sectionclasse-form__intro wage-form__intro">
                        Enregistrez le salaire d’un membre du personnel en précisant le mois,
                        le type de paiement, la caisse utilisée et le montant.
                    </p>

                    {this.state.error && (
                        <div className="sectionclasse-form__alert" role="alert">
                            <FeatherIcon icon="alert-circle" size={17} />
                            {this.state.error}
                        </div>
                    )}

                    {this.state.loading ? (
                        <div className="sectionclasse-form__loading">
                            <span className="spinner-border spinner-border-sm" />
                            Préparation du formulaire…
                        </div>
                    ) : (
                        <div className="row g-2 wage-form__grid">
                            <div className="col-lg-7 col-md-6">
                                {this.field(
                                    "wage-staff",
                                    "user-check",
                                    "Personnel",
                                    optionstaffs,
                                    "staffId",
                                    "Choisir un membre du personnel"
                                )}
                            </div>

                            <div className="col-lg-5 col-md-6">
                                {this.field(
                                    "wage-type",
                                    "briefcase",
                                    "Type",
                                    optiontypesalaries,
                                    "type",
                                    "Choisir le type de salaire"
                                )}
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <div className="wage-form__field">
                                    <label className="sectionclasse-field__label" htmlFor="wage-chartaccount">
                                        <FeatherIcon icon="credit-card" size={15} />
                                        Caisse <b>*</b>
                                    </label>

                                    <Select
                                        inputId="wage-chartaccount"
                                        classNamePrefix="sectionclasse-select"
                                        placeholder="Choisir une caisse"
                                        value={this.value(optionchartaccounts, this.state.chartaccount)}
                                        onChange={(item) =>
                                            this.setState({
                                                chartaccount: item?.value || "",
                                                max: item?.max || 0,
                                                amount: "",
                                                error: "",
                                            })
                                        }
                                        options={optionchartaccounts}
                                        noOptionsMessage={() => "Aucune caisse disponible"}
                                        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 1060 }) }}
                                    />

                                    {this.state.max > 0 && (
                                        <small className="sectionclasse-field__hint">
                                            Solde disponible : {Number(this.state.max).toLocaleString()}
                                        </small>
                                    )}
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                                {this.field(
                                    "wage-month",
                                    "calendar",
                                    "Mois",
                                    optionmonths,
                                    "month",
                                    "Choisir le mois"
                                )}
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <div className="wage-form__field">
                                    <label className="sectionclasse-field__label" htmlFor="wage-amount">
                                    <FeatherIcon icon="dollar-sign" size={15} />
                                    Montant <b>*</b>
                                </label>

                                <input
                                    id="wage-amount"
                                    type="number"
                                    min="0"
                                    className="sectionclasse-text-field"
                                    placeholder="Montant"
                                    value={this.state.amount}
                                    onChange={this.handleAmount}
                                />

                                <small className="sectionclasse-field__hint">
                                        Le montant doit être inférieur ou égal au solde de la caisse.
                                    </small>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="wage-form__field wage-form__field--textarea">
                                    <label className="sectionclasse-field__label" htmlFor="wage-reason">
                                    <FeatherIcon icon="message-square" size={15} />
                                    Commentaire
                                </label>

                                <textarea
                                    id="wage-reason"
                                    name="reason"
                                    rows={3}
                                    className="sectionclasse-text-field"
                                    placeholder="Ajouter une observation ou une justification..."
                                    value={this.state.reason}
                                    onChange={this.handleInput}
                                />
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="sectionclasse-form__footer">
                    <span>
                        <b>*</b> Champs obligatoires
                    </span>

                    <div>
                        <button
                            type="button"
                            onClick={this.props.showModal}
                            className="sectionclasse-form__cancel"
                            disabled={this.state.saving}
                        >
                            Annuler
                        </button>

                        <button
                            type="button"
                            onClick={() => this.save()}
                            className="sectionclasse-form__save"
                            disabled={this.state.loading || this.state.saving}
                        >
                            {this.state.saving ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" />
                                    Sauvegarde…
                                </>
                            ) : (
                                <>
                                    <FeatherIcon icon="check" size={17} />
                                    {editing ? "Actualiser" : "Enregistrer"}
                                </>
                            )}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default WageForm;

